export const CityEscapeReviewsQuestionIds = {
  OVERALL_EXPERIENCE_RATING: [
    "7d57646a-57f0-40ee-8611-40f620860d98",
  ] as readonly string[],
  APP_EXPERIENCE_RATING: [
    "c8c1cc53-5017-4c66-a61f-7b67a0073959",
  ] as readonly string[],
  TEXT_REVIEW: ["dd415eb0-b8e5-4938-b8e5-40e5818e3a47"] as readonly string[],
} as const;

export const QueryTags = {
  SERVICE_WORKER_BASED: "SW" as const,
} as const;
